'use strict';

var React = require('react');
var index_es = require('./index.es-8c72aff8.js');
var GridContainer = require('@swiggy-private/dls-web-core/dist/components/GridContainer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const GridWidgetLayout = ({ layout, widgets, header }) => {
    var _a, _b, _c, _d, _e;
    const containerPadding = ((_a = layout.containerStyle) === null || _a === void 0 ? void 0 : _a.containerPadding) || {};
    const widgetMargin = layout.widgetPadding || {};
    const customStyle = layout.customStyle || {};
    const displayWidgets = React.useMemo(() => {
        let currentRow = 0;
        let currentColumn = 0;
        const finalWidgets = {
            rows: [],
        };
        widgets.forEach((widget) => {
            if (finalWidgets.rows[currentRow] === undefined) {
                finalWidgets.rows[currentRow] = {
                    columns: [],
                };
            }
            if (currentColumn < layout.columns) {
                finalWidgets.rows[currentRow].columns[currentColumn] = widget;
                currentColumn++;
            }
            if (currentColumn >= layout.columns) {
                currentColumn = 0;
                currentRow++;
            }
        });
        return finalWidgets;
    }, [layout, widgets]);
    return (React__default['default'].createElement("div", { "data-testid": "grid-container", style: Object.assign({ paddingTop: `${containerPadding.top}px`, paddingBottom: `${containerPadding.bottom}px`, paddingRight: `${containerPadding.right}px`, paddingLeft: `${containerPadding.left}px`, marginTop: `${widgetMargin.top}px`, marginBottom: `${widgetMargin.bottom}px`, marginRight: `${widgetMargin.right}px`, marginLeft: `${widgetMargin.left}px` }, customStyle) },
        React__default['default'].createElement(GridContainer.GridContainer, { title: (header === null || header === void 0 ? void 0 : header.title) || "", items: displayWidgets, showScrollbar: !index_es.N(layout === null || layout === void 0 ? void 0 : layout.scrollBar), background: "transparent", hasCustomSpacing: true, containerPadding: (_b = layout === null || layout === void 0 ? void 0 : layout.containerStyle) === null || _b === void 0 ? void 0 : _b.containerPadding, widgetPadding: layout === null || layout === void 0 ? void 0 : layout.widgetPadding, headerPadding: (_c = header === null || header === void 0 ? void 0 : header.headerStyling) === null || _c === void 0 ? void 0 : _c.padding, scrollbarPadding: (_e = (_d = layout === null || layout === void 0 ? void 0 : layout.scrollBar) === null || _d === void 0 ? void 0 : _d.scrollStyling) === null || _e === void 0 ? void 0 : _e.padding, lineSpacing: layout.lineSpacing, spaceBetweenTitleAndContent: "xLarge", interItemSpacing: "medium", spaceBetweenContentAndScrollbar: "medium" })));
};
var GridWidgetLayout$1 = React__default['default'].memo(GridWidgetLayout);

exports.GridWidgetLayout = GridWidgetLayout$1;
//# sourceMappingURL=GridWidgetLayout-45f68042.js.map
